/* eslint-disable n/no-unsupported-features/node-builtins */
import { ref, type Ref } from 'vue';

interface InteractionDemoModal {
    id?: string;
    src?: string;
    breakpoint?: string[];
    abbr?: string;
}

interface InteractionDemoItem {
    modal?: InteractionDemoModal;
    [key: string]: any;
}

export function useInteractionDemo(currentBreakpointRef: Ref<string>) {
    const isVisibleDemoModal = ref(false);

    function hasInteractionDemo(item: InteractionDemoItem): boolean {
        if (!item?.modal) return false;
        if (!item.modal.id || !item.modal.src) return false;
        if (!item.modal.breakpoint?.length) return true;

        const bp = currentBreakpointRef?.value;
        return item.modal.breakpoint.includes(bp);
    }

    function logInteraction(item: InteractionDemoItem): void {
        isVisibleDemoModal.value = true;

        const abbr = item.modal?.abbr || 'ACPC';
        const hops = `demoButtonClickHops-${abbr}`;
        const name = `demoButtonClickDate-${abbr}`;

        if (!localStorage.getItem(hops)) localStorage.setItem(hops, String(0));
        if (!localStorage.getItem(name)) localStorage.setItem(name, String(new Date()));
    }

    return {
        isVisibleDemoModal,
        hasInteractionDemo,
        logInteraction,
    };
}
